
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "../components/Page";
import Head from "next/head";
import Script from "next/script";
export default function PrivacyPolicy() {
    const { t } = useTranslation("common");
    return (<Page title={"Privacy Policy"} padded>
      <Head>
        <title>Chess Hotel | Privacy policy</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      <p>
        <Script strategy="afterInteractive" dangerouslySetInnerHTML={{
            __html: `let optOutCounter = 0; 
          function setCookie(cname,cvalue,exdays){
            var d = new Date();
            d.setTime(d.getTime()+(exdays*24*60*60*1000));
            var expires='expires='+d.toUTCString();
            document.cookie=cname+'='+cvalue+';'+expires+';path=/'; 
            if(optOutCounter==0){ let cookieP = document.getElementById('cookieP'); 
              var successCookie = document.createElement('strong'); 
              successCookie.innerHTML = 'Optout Success!'; 
              successCookie.setAttribute('style','color:green'); 
              cookieP.appendChild(successCookie); 
              optOutCounter ++ 
            } 
          };`,
        }}/>
        <strong>Common ID Cookie</strong>
        <p id="cookieP">
          This site uses cookies and similar tracking technologies such as the
          Common ID cookie to provide its services. Cookies are important
          devices for measuring advertising effectiveness and ensuring a robust
          online advertising industry. The Common ID cookie stores a unique user
          id in the first party domain and is accessible to our ad partners.
          This simple ID that can be utilized to improve user matching,
          especially for delivering ads to iOS and MacOS browsers. Users can opt
          out of the Common ID tracking cookie by clicking{" "}
          <a onClick={() => {
            window.setCookie("_pubcid_optout", "1", 1825);
        }} href="#opt-out">
            here
          </a>
          .
        </p>
        <br />
        <br />
        <strong>Advertising Privacy Settings</strong>
        <p>
          FOR EU USERS ONLY: When you use our site, pre-selected companies may
          access and use certain information on your device and about your
          interests to serve ads or personalized content. You may revisit or
          change consent-choices at any time by clicking{" "}
          <a href="#cmp" onClick={() => {
            if (window.__cmp === undefined) {
                console.warn("User is not in the EU - Consent Choices can only be configured when User is in the EU");
            }
            else {
                window.__cmp("showConsentTool");
            }
        }}>
            here
          </a>
          .
        </p>
        <br />
        <br />
        <strong>What information do we collect?</strong> <br />
        We collect information from you when you register on our site. This
        information consists of a username, email, password and country code.
        The password is never read in plain text and is always stored encrypted
        in our database. <br />
        <br />
        When registering with Facebook only your facebook-id, username and
        country code is strored and when registering with Apple your
        apple-token, username and county code is stored.
        <br />
        You may also visit our site anonymously as a Guest.
        <br />
        <br />
        Third party vendors, including Google, use cookies to serve ads based on
        a user's prior visits to your website or other websites.
        <br />
        <br />
        Google's use of advertising cookies enables it and its partners to serve
        ads to your users based on their visit to your sites and/or other sites
        on the Internet.
        <br />
        <br />
        Users may opt out of personalized advertising by visiting{" "}
        <a href="https://www.google.com/settings/ads">Ads Settings</a>
        <br />
        <br />
        <br />
        <strong>What do we use your information for?</strong> <br />
        Any of the information we collect from you may be used in one of the
        following ways: <br />
        <br />- To personalize your experience
        <br />
        Your information helps us to better respond to your individual needs.
        <br />
        <br />- To improve our website
        <br />
        We continually strive to improve our website offerings based on the
        information and feedback we receive from you.
        <br />
        <br />- To send periodic emails
        <br />
        The email address you provide may be used to send you information,
        respond to inquiries, and/or other requests or questions.
        <br />
        <br />
        <br />
        <strong>How do we protect your information?</strong> <br />
        We implement a variety of security measures to maintain the safety of
        your personal information when you enter, submit, or access your
        personal information. <br /> <br />
        We offer the use of a secure server. All supplied sensitive/credit
        information is transmitted via Secure Socket Layer (SSL) technology and
        then encrypted into our database only to be accessible by those
        authorized with special access rights to such systems, and are required
        to keep the information confidential.
        <br />
        <br />
        After a transaction, your private information (credit cards, social
        security numbers, financials, etc.) will not be stored on our servers.
        <br />
        <br />
        <br />
        <strong>How can your data be deleted?</strong>
        <br />
        If you want your data deleted it can be done upon request (via email to
        david@chesshotel.com), upon closure of your account, or after three
        years of inactivity. Data may still remain in the systems back-up files,
        which will be deleted every other day.
        <br />
        <br />
        <br />
        <strong>Do we use cookies?</strong> <br />
        Yes (Cookies are small files that a site or its service provider
        transfers to your computers hard drive through your Web browser (if you
        allow) that enables the sites or service providers systems to recognize
        your browser and capture and remember certain information
        <br />
        <br /> We use cookies to understand and save your preferences for future
        visits.
        <br />
        <br />
        <br />
        <strong>Do we disclose any information to outside parties?</strong>
        <br />
        We do not sell, trade, or otherwise transfer to outside parties your
        personally identifiable information. This does not include trusted third
        parties who assist us in operating our website, conducting our business,
        or servicing you, so long as those parties agree to keep this
        information confidential. We may also release your information when we
        believe release is appropriate to comply with the law, enforce our site
        policies, or protect ours or others rights, property, or safety.
        However, non-personally identifiable visitor information may be provided
        to other parties for marketing, advertising, or other uses.
        <br />
        <br />
        <br />
        <strong>Third party links</strong>
        <br /> Occasionally, at our discretion, we may include or offer third
        party products or services on our website. These third party sites have
        separate and independent privacy policies. We therefore have no
        responsibility or liability for the content and activities of these
        linked sites. Nonetheless, we seek to protect the integrity of our site
        and welcome any feedback about these sites.
        <br />
        <br />
        <br />
        <strong>California Online Privacy Protection Act Compliance</strong>
        <br />
        Because we value your privacy we have taken the necessary precautions to
        be in compliance with the California Online Privacy Protection Act. We
        therefore will not distribute your personal information to outside
        parties without your consent.
        <br />
        <br />
        As part of the California Online Privacy Protection Act, all users of
        our site may make any changes to their information at anytime by logging
        into their control panel and going to the 'Edit Profile' page.
        <br />
        <br />
        <br />
        <strong>Online Privacy Policy Only</strong> <br />
        This online privacy policy applies only to information collected through
        our website and not to information collected offline.
        <br />
        <br />
        <br />
        <strong>Terms and Conditions</strong> <br />
        Please also visit our Terms and Conditions section establishing the use,
        disclaimers, and limitations of liability governing the use of our
        website at{" "}
        <a href="https://www.chesshotel.com/termsofservice/">
          https://www.chesshotel.com/termsofservice
        </a>
        <br />
        <br />
        <br />
        <strong>Your Consent</strong> <br />
        By using our site, you consent to our privacy policy.
        <br />
        <br />
        <br />
        <strong>Changes to our Privacy Policy</strong> <br />
        If we decide to change our privacy policy, we will post those changes on
        this page. <br />
        <br />
        <br />
        <strong>Contacting Us</strong> <br />
        If there are any questions regarding this privacy policy you may contact
        us using the information below. <br />
      </p>
      <p>
        <a href="mailto:david@chesshotel.com">David Shore</a>
        <br />
        Foggy Media AB
        <br />
        Stockholm, Sweden
      </p>
      <br />
      <br />
    </Page>);
}

    async function __Next_Translate__getStaticProps__18ae0631eb2__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/privacypolicy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18ae0631eb2__ as getStaticProps }
  